import "./src/assets/fonts/fonts.css";

if (typeof window.IntersectionObserver === "undefined") {
    import("intersection-observer");
}
